//developer mode
const developerModeLevel = 2;//0:off | 1:important | 2:normal | 3:annoying logs (e.g. on every scroll event)



const coverID = 'cover';
const headerID = 'site-header';
const headerCoverID = 'site-header-cover';
const contentID = "site-content";

//cover aspect ratio (deprecated)
let landscapeMode = true;//don't change


//cover size settings
const homePageCoverSettings = {
    coverID: 'cover',
    aspectRatio: {
        range:  [ 1, 21/9 ],// 0.8, 1.777777778
        skipRange: [ 0, 0 ],// 1.25, 1.333333333
    },
    targetCoverage: 100,// 100 (percent)
}
const projectPageCoverSettings = {
    coverID: 'project-cover',
    aspectRatio: {
        range:  [ 1, 22/9 ],// 0.8, 1.777777778
        skipRange: [ 0, 0 ],// 1.25, 1.333333333
    },
    targetCoverage: 50,// 100 (percent)
}

//scroll direction check
let _prevScrollTop = 0; 
let _scrollDirection = 0;// none: 0||down: 1||up: -1

// scrollDirectionChangeEvent
let _prevScrollDirection = 0;

//sliding sticky elem
let _sseTop = 0;
let _sseScrollTop = 0;

//
let coverBottom = 0;

const consoleGreatingsText =
String.raw`
 ___ _____ _   _ ___ ___ ___   
/ __|_   _| | | |   \_ _/ _ \  
\__ \ | | | |_| | |) | | (_) | 
|___/ |_|  \___/|___/___\___/_ 
| _ ) /_\ | _ \  /_\_   _| || |
| _ \/ _ \|   / / _ \| | | __ |
|___/_/ \_\_|_\/_/ \_\_| |_||_|



READY.
■


`;